import { signal } from "@angular/core";

export const isEditMode = signal(false);
